import { $g } from './global';
class MiStorage {
    prefix;
    instance;
    constructor(type) {
        this.prefix = $g.prefix;
        this.change(type);
    }
    get(keys, prefix) {
        let data = {};
        if (Array.isArray(keys)) {
            for (let i = 0, len = keys.length; i < len; i++) {
                const key = keys[i];
                const item = `${prefix ?? this.prefix}${key}`;
                data[key] = JSON.parse(this.instance.getItem(item));
            }
        }
        else {
            data = null;
            const key = `${prefix ?? this.prefix}${keys}`;
            if (keys)
                data = JSON.parse(this.instance.getItem(key));
        }
        return data;
    }
    set(key, value, prefix) {
        const item = `${prefix ?? this.prefix}${key}`;
        this.instance.setItem(item, JSON.stringify(value));
    }
    del(keys, prefix) {
        if (Array.isArray(keys)) {
            for (let i = 0, len = keys.length; i < len; i++) {
                const key = keys[i];
                const item = `${prefix ?? this.prefix}${key}`;
                this.instance.removeItem(item);
            }
        }
        else {
            const item = `${this.prefix}${keys}`;
            this.instance.removeItem(item);
        }
    }
    change(type) {
        this.instance =
            type === 'local' ? localStorage : type === 'session' ? sessionStorage : localStorage;
        return this;
    }
    install(app) {
        return app;
    }
}
export const $storage = new MiStorage();
export default {
    install(app) {
        app.config.globalProperties.$storage = $storage;
        app.provide('$storage', $storage);
        return app;
    }
};
